import { useAppSelector, useAppDispatch } from "../../app/hooks";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import {
  selectStreamSlots,
  selectLayout,
  selectWaitingScreen,
  selectDesiredVolume,
  selectSetVolume,
  changeSetVolume
} from "./layoutSlice";
import { camList } from "../../app/streamData";
import { VolumeControl } from "./volume/volumeControl";
import {
  useUpdateStreamLayoutMutation,
  useAddWaitingLayoutMutation,
  useRemoveWaitingLayoutMutation,
} from "../../api/apiSlice";

export function LayoutPublisher() {
  const currentSlots = useAppSelector(selectStreamSlots);
  const currentLayout = useAppSelector(selectLayout);
  const presetVolume = useAppSelector(selectSetVolume);
  const waitingScreen = useAppSelector(selectWaitingScreen);
  const desiredVolume = useAppSelector(selectDesiredVolume);
  const [updateLayout] = useUpdateStreamLayoutMutation();
  const [addWaitingLayout] = useAddWaitingLayoutMutation();
  const [removeWaitingLayout] = useRemoveWaitingLayoutMutation();
  const dispatch = useAppDispatch();

  const onPublishClicked = async (ev: React.MouseEvent) => {
    var streamUrls = currentSlots.map((name) => {
      var cam = camList.find((stream) => stream.name === name);
      return cam ? cam.streamUrl : null;
    });
    var body = {
      name: currentLayout,
      cameras: streamUrls,
      volume: desiredVolume,
    };
    updateLayout(body);
    dispatch(changeSetVolume(desiredVolume))
  };

  var waitingScreenButton = (
    <Button variant="primary" onClick={(ev) => addWaitingLayout(ev)}>
      Add Waiting Screen
    </Button>
  );
  if (waitingScreen) {
    waitingScreenButton = (
      <Button variant="danger" onClick={(ev) => removeWaitingLayout(ev)}>
        Remove Waiting Screen
      </Button>
    );
  }

  var publishVariant = (desiredVolume === presetVolume) ? "primary" : "warning"
  return (
    <Row>
      <Col className="mt-4" xs={4}>
        {waitingScreenButton}
      </Col>
      <Col className="mt-4" xs={4}>
        <VolumeControl presetVolume={presetVolume}/>
      </Col>
      <Col className="mt-4" xs={4}>
        <Button variant={publishVariant} onClick={(ev) => onPublishClicked(ev)}>
          Publish
        </Button>
      </Col>
    </Row>
  );
}
